module.exports = __webpack_public_path__ + "img/img-1.489259c6.png";